import { environment } from '@env/environment';
import SuperTokens from 'supertokens-web-js';
import EmailVerification from 'supertokens-web-js/recipe/emailverification';
import Passwordless from 'supertokens-web-js/recipe/passwordless'; // Add this if not imported
import Session from 'supertokens-web-js/recipe/session';

type PreAPIHookContext = {
  requestInit: RequestInit;
  url: string;
};

// export function initSuperTokensWebJS() {
//   SuperTokens.init({
//     appInfo: {
//       appName: 'Thkee',
//       apiDomain: environment.serverUrl,
//     },
//     recipeList: [Session.init({ sessionTokenFrontendDomain: environment.thkCookieDomain }), EmailVerification.init()],
//   });
// }

export function createPreAPIHook(getCountryHeader: () => string) {
  return async ({ requestInit, url }: PreAPIHookContext) => {
    requestInit.headers = {
      ...(requestInit.headers || {}),
      'x-country': getCountryHeader(),
    };
    return { requestInit, url };
  };
}

export function initSuperTokensWebJS(getCountryHeader: () => string) {
  const preAPIHook = createPreAPIHook(getCountryHeader);
  SuperTokens.init({
    appInfo: {
      appName: 'Thkee',
      apiDomain: environment.serverUrl,
    },
    recipeList: [
      Session.init({
        sessionTokenFrontendDomain: environment.thkCookieDomain,
        preAPIHook, // For x-country header
      }),
      EmailVerification.init(),
      Passwordless.init({
        preAPIHook, // For x-country header
      }),
    ],
  });
}
